import React from 'react';

import type { IPackageId } from './types';

import styles from './packageId.module.css';

const PackageId = ({ id }: IPackageId) => (
  <div className={styles.text}>{`№ ${id}`}</div>
);

export default PackageId;
